
interface Logo {
  id: string;
  description: string;
  image: string;
  className?: string;
}

interface Logos3Props {
  heading?: string;
  logos?: Logo[];
  className?: string;
}

const defaultLogos = [
  {
    id: "logo-1",
    description: "My First Million Podcast",
    image: "/lovable-uploads/7bc01bdb-22bb-491f-8b0f-60cd673b794a.png",
    className: "h-32 w-auto",
  },
  {
    id: "logo-2",
    description: "Lex Fridman Podcast",
    image: "/lovable-uploads/5028271c-e08c-46f3-bf22-77a9b7d54f71.png",
    className: "h-32 w-auto",
  },
  {
    id: "logo-3",
    description: "The Tim Ferriss Show",
    image: "/lovable-uploads/366ee630-5d50-4210-813a-ad753d6f94f9.png",
    className: "h-32 w-auto",
  },
  {
    id: "logo-4",
    description: "Armchair Expert",
    image: "/lovable-uploads/82f5420d-d69a-422f-915c-51a9d931516b.png",
    className: "h-32 w-auto",
  },
  {
    id: "logo-5",
    description: "Daily Stoic",
    image: "/lovable-uploads/96a995c4-f625-4f81-b370-56e2e663d093.png",
    className: "h-32 w-auto",
  }
];

const Logos3 = ({
  heading = "Join the Best Podcasters in Austin",
  logos = defaultLogos,
}: Logos3Props) => {
  return (
    <section className="py-16 bg-studio-cream overflow-hidden">
      <div className="container flex flex-col items-center text-center">
        <h2 className="my-6 text-2xl font-bold text-studio-sage lg:text-4xl">
          {heading}
        </h2>
      </div>
      <div className="flex overflow-hidden relative w-full">
        <div className="flex animate-marquee whitespace-nowrap">
          {[...logos, ...logos].map((logo, index) => (
            <div
              key={`${logo.id}-${index}`}
              className="flex-none px-8 flex items-center"
            >
              <img
                src={logo.image}
                alt={logo.description}
                className={logo.className}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export { Logos3 };
